import { COLORS } from "shared/consts";

export const SearchIcon = () => <svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"
                                     width="20.000000" height="20.000000"
                                     fill="none">
    <path id="Union"
          d="M14.5833 9.16667C14.5833 12.1582 12.1582 14.5833 9.16667 14.5833C6.17512 14.5833 3.75 12.1582 3.75 9.16667C3.75 6.17512 6.17512 3.75 9.16667 3.75C12.1582 3.75 14.5833 6.17512 14.5833 9.16667ZM13.4181 14.302C12.2642 15.2584 10.7826 15.8333 9.16667 15.8333C5.48477 15.8333 2.5 12.8486 2.5 9.16667C2.5 5.48477 5.48477 2.5 9.16667 2.5C12.8486 2.5 15.8333 5.48477 15.8333 9.16667C15.8333 10.7826 15.2584 12.2642 14.302 13.4181L17.4992 16.6153L16.6154 17.4992L13.4181 14.302Z"
          fill={COLORS.FG.MUTED} fillRule="evenodd"/>
</svg>

